import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { ProductRoutingModule } from './product-routing.module';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { productDetailsComponent } from './components/product-details/product-details.component';
import { EditProfileComponent } from './components/edit-profile/edit-profile.component';
import { OrderDetailComponent } from './components/order-detail/order-detail.component';
import { ProfileComponent } from './components/profile/profile.component';
import { ShopSummaryComponent } from './components/shop-summary/shop-summary.component';
import { WhishListComponent } from './components/whish-list/whish-list.component';
import { DisableInputDirective } from '../shared/directive/disable-input.directive';
import { DecimalLimitDirective } from '../shared/directive/decimal-limit.directive';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { LAZYLOAD_IMAGE_HOOKS, LazyLoadImageModule } from 'ng-lazyload-image';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SharedModule } from '../shared/shared.module';
import { PaymentStatusComponent } from './components/payment-status/payment-status.component';
import { TranslateModule } from '@ngx-translate/core';
import { PaymentDialogComponent } from './components/payment-dialog/payment-dialog.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import { PaymentComponent } from './components/payment/payment.component';
import { LogoutDialogComponent } from './components/logout-dialog/logout-dialog.component';
import { WalletComponent } from './components/wallet/wallet.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { ChargeWalletSheetComponent } from './components/charge-wallet-sheet/charge-wallet-sheet.component';
import { TransactionDetailComponent } from './components/transaction-detail/transaction-detail.component';
import { WalletPaymentDialogComponent } from './components/wallet-payment-dialog/wallet-payment-dialog.component';
import { PaymentTabComponent } from './components/payment-tab/payment-tab.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { CategoryModule } from '../category/category.module';
import { BillingInfoComponent } from './components/billing-info/billing-info.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DndDirective } from '../shared/directive/dnd.directive';
import { KycFormComponent } from './components/kyc-form/kyc-form.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatNativeDateModule
} from '@angular/material/core';
import { LazyLoadService } from '../shared/services/lazy-load.service';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter
} from '@angular/material-moment-adapter';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ProductHeaderComponent } from './components/product-details/views/product-header/product-header.component';
import { MatChipsModule } from '@angular/material/chips';
import { NoteBoxComponent } from './components/product-details/views/note-box/note-box.component';
import { RelatedProductsComponent } from './components/product-details/views/related-products/related-products.component';
import { PaymentBoxComponent } from './components/product-details/views/payment-box/payment-box.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTableModule } from '@angular/material/table';
import { ProductPricePipe } from '../shared/pipes/convert-price.pipe';
import { PaymentCtaContainerComponent } from './components/product-details/views/payment-cta-container/payment-cta-container.component';
import { ProductCategoriesComponent } from './components/product-details/views/product-categories/product-categories.component';
import { GiftDrawerComponent } from './components/product-details/views/gift-drawer/gift-drawer.component';
import { GiftFormComponent } from './components/product-details/views/gift-drawer/gift-form/gift-form.component';
import { ProductDetailsMobileComponent } from './components/product-details/mobile/product-details-mobile.component';
import { ProductDetailsDesktopComponent } from './components/product-details/desktop/product-details-desktop.component';
import { ProductAvatarComponent } from './components/product-details/views/product-avatar/product-avatar.component';
import { ProductTitleComponent } from './components/product-details/views/product-title/product-title.component';
import { PriceLabelComponent } from './components/product-details/views/price-label/price-label.component';
import { ProductExpansionComponent } from './components/product-details/views/product-expantion/product-expansion.component';
import { ProductDescriptionComponent } from './components/product-details/views/product-description/product-description.component';
import { ProductKpiComponent } from './components/product-details/views/product-kpi/product-kpi.component';
import { KingClubModule } from '../king-club/king-club.module';
import { PaymentMethodsComponent } from './components/payment-methods/payment-methods.component';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'YYYY.MM.DD'
  },
  display: {
    dateInput: 'yyyy.MMM.DD',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@NgModule({
  declarations: [
    ChangePasswordComponent,
    productDetailsComponent,
    EditProfileComponent,
    OrderDetailComponent,
    ProfileComponent,
    ShopSummaryComponent,
    WhishListComponent,
    DisableInputDirective,
    DecimalLimitDirective,
    PaymentStatusComponent,
    PaymentDialogComponent,
    PaymentComponent,
    LogoutDialogComponent,
    WalletComponent,
    ChargeWalletSheetComponent,
    TransactionDetailComponent,
    WalletPaymentDialogComponent,
    PaymentTabComponent,
    BillingInfoComponent,
    DndDirective,
    KycFormComponent,
    ProductHeaderComponent,
    NoteBoxComponent,
    RelatedProductsComponent,
    PaymentBoxComponent,
    ProductExpansionComponent,
    PaymentCtaContainerComponent,
    ProductCategoriesComponent,
    GiftDrawerComponent,
    GiftFormComponent,
    ProductDetailsMobileComponent,
    ProductDetailsDesktopComponent,
    ProductAvatarComponent,
    ProductTitleComponent,
    PriceLabelComponent,
    ProductDescriptionComponent,
    ProductKpiComponent,
    PaymentMethodsComponent
  ],
  imports: [
    CommonModule,
    ProductRoutingModule,
    InfiniteScrollModule,
    LazyLoadImageModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatFormFieldModule,
    SharedModule,
    TranslateModule,
    MatChipsModule,
    MatExpansionModule,
    MatStepperModule,
    MatTabsModule,
    MatRadioModule,
    MatBottomSheetModule,
    SlickCarouselModule,
    CategoryModule,
    ClipboardModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatTableModule,
    KingClubModule
  ],
  providers: [
    DatePipe,
    ProductPricePipe,
    { provide: LAZYLOAD_IMAGE_HOOKS, useClass: LazyLoadService },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }
  ]
})
export class ProductModule {}
